import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import {
  INTERACTION_TYPES_FOR,
  INTERACTION_TYPE_LABELS,
} from "../../constants";
import type { InteractionSelectorProps } from "../../types/interactionSelector";
import type { InteractionType } from "../../types/interactions";

const InteractionSelector = (props: InteractionSelectorProps) => {
  const { value, entityType, onChange } = props;

  return (
    <div className="space-y-1">
      <Label>Interaction type</Label>
      <Select
        value={value}
        onValueChange={(v) => onChange(v as InteractionType)}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {INTERACTION_TYPES_FOR[entityType].map((type) => (
            <SelectItem key={type} value={type}>
              {INTERACTION_TYPE_LABELS[type]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default InteractionSelector;
